import React, { useEffect, useState } from "react";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import ligthray from "assets/img/convention/ligthray.png";
import style from "./MainSectionStyle";
import { makeStyles } from "@material-ui/core/styles";
import ContainerFullHeight from "components/ContainerFullHeight/ContainerFullHeight";
import { useTranslation } from "react-i18next";

import carouselStyle from "assets/jss/material-kit-pro-react/views/componentsSections/carouselStyle.js";
import Carousel from "react-slick";

import image1 from "assets/img/25/Imagen 1.jpeg";
import image2 from "assets/img/25/Imagen 2.jpg";
import image3 from "assets/img/25/Imagen 4.jpeg";
import image4 from "assets/img/25/Imagen 5.jpg";
import image5 from "assets/img/25/Imagen 6.jpg";
import image6 from "assets/img/25/Imagen 7.jpg";
import image7 from "assets/img/25/Imagen 8.jpg";
import image8 from "assets/img/25/Imagen 9.jpg";
import image9 from "assets/img/25/Imagen 10.jpg";
import Button from "components/CustomButtons/Button.js";
import { Link } from "react-router-dom/cjs/react-router-dom";

const useStyles = makeStyles(style, carouselStyle);

export default function MainSection({ id, t }) {
  const { i18n } = useTranslation(["homePage"]);
  const classes = useStyles();
  const settings = {
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false
  };

  const cotaLink = "https://www.conventionoftheamericas.com/login-page";
  const subtitles = [
    t("meetingSubtitle"),
    t("meetingSubtitle1"),
  ];
  const [currentSubtitleIndex, setCurrentSubtitleIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);
  useEffect(() => {
    const interval = setInterval(() => {
      setIsFading(true);
  
      setTimeout(() => {
        setCurrentSubtitleIndex((prevIndex) => (prevIndex + 1) % subtitles.length);
        setIsFading(false);
      }, 1000);
    }, 5000);
  
    return () => clearInterval(interval);
  }, []);

  const videoPanel = function () {
    return (
      <GridItem>
        <div className={classes.fixedTextContainer}>
          <h1 className={classes.fixedTextTitle}>
            <strong> {t("meetingTitle")} </strong>
          </h1>
          <h3 className={`${classes.fixedTextSubtitle} ${isFading ? classes.fadeOut : classes.fadeIn}`}>{subtitles[currentSubtitleIndex]}</h3>
            <Link to={"/register"}>
                <Button
                color="info"
                size="lg"
                className={classes.fixedTextButton}
                href={cotaLink}
                target="_blank"
                >{t("signUpButton")}
              </Button>
            </Link>
        </div>
        <div style={{ position: "relative" }}>
        <div className={classes.carouselOverlay}></div>
        <Carousel {...settings}>
          <div>
            <img src={image1} alt="First slide" className="slick-image" style={{ borderRadius: "16px"}} />
          </div>
          <div>
            <img src={image2} alt="Second slide" className="slick-image" style={{ borderRadius: "16px"}} />
          </div>
          <div>
            <img src={image3} alt="Third slide" className="slick-image" style={{ borderRadius: "16px"}} />
          </div>
          <div>
            <img src={image4} alt="First slide" className="slick-image" style={{ borderRadius: "16px"}} />
          </div>
          <div>
            <img src={image5} alt="First slide" className="slick-image" style={{ borderRadius: "16px"}} />
          </div>
          <div>
            <img src={image6} alt="First slide" className="slick-image" style={{ borderRadius: "16px"}} />
          </div>
          <div>
            <img src={image7} alt="First slide" className="slick-image" style={{ borderRadius: "16px"}} />
          </div>
          <div>
            <img src={image8} alt="First slide" className="slick-image" style={{ borderRadius: "16px"}} />
          </div>
          <div>
            <img src={image9} alt="First slide" className="slick-image" style={{ borderRadius: "16px"}} />
          </div>
        </Carousel>
        </div>
      </GridItem>
    );
  };
  return (
    <ContainerFullHeight
      alignItems="start"
      bgColor="white"
      paddingBottom="20px"
    >
      <div
        style={{
          position: "absolute",
          width: "35vw",
          height: "35vw",
          backgroundColor: "#CABDA3",
          top: "-20px",
          zIndex: "1",
          borderRadius: "50%",
          right: "-100px",
          minWidth: "300px",
          minHeight: "300px",
        }}
      ></div>
      <div className={classes.container} id={id}>
        <GridContainer className={classes.titleContainer}>
          {/* <GridItem xs={12} sm={12} md={6}>
            <h2 className={classes.title}>{t("mainSubtitle")}</h2>
            <h3 className={classes.subtitle}>{t("meetingTitle")}</h3>
            <h3 className={classes.subtitleI}>{t("meetingSubtitle")}</h3>
            <br />
            <ParagraphMain
              className={classes.paragraph}
              text={t("meetingText")}
            />
            <Link to={"/register"}>
              <Button
                color="info"
                size="lg"
                target="blank"
                className={classes.navButton}
              >
                {t("signUpButton")}
              </Button>
            </Link>
          </GridItem> */}
          {videoPanel()}
          {/* <GridItem xs={12} sm={12}>
            <DonatePaypal
              text={t("donateText")}
              buttonText={t("donatePaypal")}
            />
          </GridItem> */}
          {/*<GridItem xs={12} md={12}>
            <Pricing buttonText={t("pricingButton")} />
  </GridItem>*/}
          {/*<GridItem
            xs={12}
            md={6}
            className={classes.navButtonContainerSchedule}
          >
            <Button
              color="info"
              size="lg"
              href={schedulePDF}
              target="blank"
              download="Programa-Schedule"
            >
              {t("scheduleButton")}
            </Button>
  </GridItem>*/}
        </GridContainer>
      </div>
      <div
        style={{ backgroundImage: `url("${ligthray}")` }}
        className={classes.lightray}
      ></div>
    </ContainerFullHeight>
  );
}
